// extracted by mini-css-extract-plugin
export default {"card":"RepoCard_card__lzqPB","title":"RepoCard_title__hjJjo","stats":"RepoCard_stats__0e6pp","icon":"RepoCard_icon__q+OKC"};